import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, mergeMap } from 'rxjs';

import { EffectsBase } from '@ps/core-data-access';

import { SurveyActivityLogService } from '../../services/survey-activity-log/survey-activity-log.service';
import { SurveyActivityLogActions } from './survey-activity-log.actions';

@Injectable()
export class SurveyActivityLogEffects extends EffectsBase {
  private readonly _actions$ = inject(Actions);
  private readonly _service = inject(SurveyActivityLogService);

  public readonly logActivity$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(SurveyActivityLogActions.logActivity),
        mergeMap(({ log }) =>
          this._service.logActivity(log).pipe(this.psCatchError(() => EMPTY)),
        ),
      ),
    { dispatch: false },
  );

  public readonly logOperatorActivity$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(SurveyActivityLogActions.logOperatorActivity),
        mergeMap(({ log }) =>
          this._service
            .logOperatorActivity(log)
            .pipe(this.psCatchError(() => EMPTY)),
        ),
      ),
    { dispatch: false },
  );
}
